'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppAuthData(token) {
  this.Xx = null;
  this.Xx = token;
}
export { $c_Lapp_data_AppAuthData as $c_Lapp_data_AppAuthData };
$p = $c_Lapp_data_AppAuthData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppAuthData;
/** @constructor */
function $h_Lapp_data_AppAuthData() {
}
export { $h_Lapp_data_AppAuthData as $h_Lapp_data_AppAuthData };
$h_Lapp_data_AppAuthData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_AppAuthData) && (this.Xx === x$0.Xx)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "AppAuthData";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Xx;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "token";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AppAuthData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iC)));
}
export { $isArrayOf_Lapp_data_AppAuthData as $isArrayOf_Lapp_data_AppAuthData };
var $d_Lapp_data_AppAuthData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppAuthData, "app.data.AppAuthData", ({
  iC: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppAuthData as $d_Lapp_data_AppAuthData };
//# sourceMappingURL=app.data.-App-Auth-Data.js.map
